import React from 'react';
import styled, { css } from 'styled-components';
import { Post, Shapeable } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { applyOpenGraphThumbnailSize, classNames } from '@shapeable/utils';
import { Page, Person } from '@shapeable/gesda-types';
import { EntityPublicationCard, EntityPublicationCardDefaultProps, EntityPublicationCardProps } from './entity-publication-card';
const cls = classNames('page-publication-card');

// -------- Types -------->

// -------- Props -------->

export type PostPublicationCardProps = Omit<EntityPublicationCardProps, 'entity'> & { 
  entity?: Post;
};

export const PostPublicationCardDefaultProps: Omit<PostPublicationCardProps, 'entity'> = {
  ...EntityPublicationCardDefaultProps,
};

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    ${theme.FILL('dark')};
  `,
});

const ContributorsStyles = css`
  font-weight: 300;
  font-size: ${14/14}em;
  line-height: 1.30em;
  color: ${theme.COLOR('text-subtle')};
  padding-top: ${theme.UNIT(5)};
`;

const AuthorsStyles = css`
  display: block;
`;

const PeopleStyles = css`
  display: block;
`;
// -------- Components -------->

const My = {
  Container: styled(EntityPublicationCard)<ContainerProps>`${ContainerStyles}`,
  Contributors: styled.div`${ContributorsStyles}`,
    Authors: styled.span`${AuthorsStyles}`,
    People: styled.span`${PeopleStyles}`,
};

export const PostPublicationCard: Shapeable.FC<PostPublicationCardProps> = (props) => {
  const { className, entity, ...cardProps } = props;

  const { authors = [], people = [] } = entity;

  const transformedEntity: Person = applyOpenGraphThumbnailSize('bubbleLarge')(props.entity);

  const authorNames = authors.map((author) => author.name).join(', ');
  const authorsLabel = authorNames ? `${authorNames} (Authors)` : '';

  const visiblePeople = people.slice(0, 6);
  const personNames = visiblePeople.map((person) => person?.name || '').filter(Boolean).join(', ');
  const remainingPeopleCount = people.length - visiblePeople.length;
  const contributorsLabel = personNames
    ? remainingPeopleCount > 0
      ? `${personNames}, +${remainingPeopleCount} (People)`
      : `${personNames} (People)`
    : '';

  return (
    <My.Container 
      {...cardProps} 
      entity={transformedEntity}
      foot={
        <My.Contributors> 
          {
            authorsLabel && (
              <My.Authors>{authorsLabel}</My.Authors>
            )
          } 
        {
          contributorsLabel && (
            <My.Contributors>{contributorsLabel}</My.Contributors>
          )
        }
        </My.Contributors>
      }
      />
  )
};

PostPublicationCard.defaultProps = PostPublicationCardDefaultProps;
PostPublicationCard.cls = cls;